module.exports = __webpack_public_path__ + "static/media/plane-arrival.fea65673.svg";